package com.example.mystybag.pdf.model

import com.example.mystybag.pdfUtils.expected.PdfFile

data class PdfUrlUIState(
    val isDownloadButtonVisible : Boolean   = false,
    var pdfFile                 : PdfFile?  = null
)